import {AfterViewInit, Component, ComponentRef, Injector, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {RouteViewModel, StopViewModel} from "../Model/RouteViewModel";
import {GeozoneViewModel} from "../../Geozone/Model/GeozoneViewModel";
import {DialogService} from "../../../../services/dialog.service";
import {BaseDialog} from "../../BaseDialog";
import {ZoneMgmtComponent} from "./zone-mgmt-component/zone-mgmt-component.component";
import {TranslateService} from "@ngx-translate/core";
import {RoutesService} from "../../../../services/routes.service";

@Component({
    selector: 'app-routes-dialog-base',
    templateUrl: './routes-dialog-base.component.html',
    styleUrls: ['./routes-dialog-base.component.css'],
    standalone: false
})
export class RoutesDialogBaseComponent extends DialogBaseComponent<RouteViewModel> implements AfterViewInit {
  @ViewChild("mgmtDialog", { read: ViewContainerRef, static: true }) container;
  protected componentRef: ComponentRef<any>;
  protected dialogService: DialogService;
  private translateService: TranslateService;
  protected routesService: RoutesService;

  protected prepareModal<T>(dialogType: Type<BaseDialog>) {
    this.componentRef = this.dialogService.open(this.container, dialogType);
  }
  public updated: any;
  public zones: GeozoneViewModel[] = [];

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogService = injector.get(DialogService);
    this.translateService = injector.get(TranslateService);
    this.routesService = injector.get(RoutesService);
  }

  ngAfterViewInit() {
  }

  public addZone() {
    this.prepareModal(ZoneMgmtComponent);
    this.componentRef.instance.zones = this.zones;
    this.componentRef.instance.onSubmit.subscribe(() => {
      let stop = this.componentRef.instance.model;
      stop.Order = this.model.Stops.length;
      this.model.Stops.push(stop);
    });
    this.componentRef.instance.open(new StopViewModel());
  }

  public editZone(stop: StopViewModel) {
    this.prepareModal(ZoneMgmtComponent);
    var clone = Object.assign({}, stop);
    this.componentRef.instance.zones = this.zones;
    this.componentRef.instance.onSubmit.subscribe(() => {
      let stop = this.componentRef.instance.model;
      let oldZone = this.model.Stops.find(s => s.Id == this.componentRef.instance.model.Id);
      if (oldZone) {
        let idx = this.model.Stops.indexOf(oldZone);
        if (idx >= 0)
          this.model.Stops.splice(idx, 1);
      }

      this.model.Stops.push(stop);
      this.updated = new Date();
    });
    this.componentRef.instance.open(clone);
  }

  public getZoneName(stop:StopViewModel) {
    let zone = this.zones.find(z => z.Id == stop.ZoneId);
    if (zone) {
      return zone.Name;
    }
    return "";
  }

  public getTime(stop: StopViewModel) {
    let hours = Math.floor(stop.Time / 3600);
    let minutes = Math.floor((stop.Time - hours * 3600) / 60);
    let seconds = stop.Time - hours * 3600 - minutes * 60;
    let result = "";
    if (hours > 0)
      result += hours + " " + this.translateService.instant("h") + " ";
    if (minutes > 0)
      result += minutes + " " + this.translateService.instant("min") + " ";
    if (seconds > 0)
      result += seconds + " " + this.translateService.instant("sec");
    return result;
  }

  public removeZone(stop: StopViewModel) {
    let message = this.translateService.instant("Delete");
    if (!confirm(message + " " + this.getZoneName(stop) + "?")) return;
    var idx = this.model.Stops.indexOf(stop);
    if (idx >= 0)
      this.model.Stops.splice(idx, 1);
  }

  public pullUp(stop: StopViewModel) {
    let prevStop = this.model.Stops.find(s => s.Order == (stop.Order - 1));
    if (prevStop) {
      prevStop.Order++;
      stop.Order--;
      this.updated = new Date();
    }
  }

  public pullDown(stop: StopViewModel) {
    let prevStop = this.model.Stops.find(s => s.Order == (stop.Order + 1));
    if (prevStop) {
      prevStop.Order--;
      stop.Order++;
      this.updated = new Date();
    }
  }

}
